<script setup lang="ts">
import {computed} from "vue";

const props = withDefaults(defineProps<{
    max?: number
    rating: number
    count: number
}>(), {
    max: 5
});

const getStarClass = (index: number) => {
    const prefix = "icon-star-";
    
    if (index <= props.rating) {
        return prefix + "active";
    }
    if (index - 0.5 <= props.rating) {
        return prefix + "half";
    }
    return prefix + "empty";
};

const reviewMultiplicityName = computed(() => {
    return props.count === 1 ? 'review' : 'reviews';
});

 const ariaLabel = computed(() => {
     return props.rating + ' van de ' + props.max + ' sterren'
 })

</script>

<template>
    <ul v-if="rating > 0 && count > 0" class="rating" :aria-label="ariaLabel">
        <li v-for="i in props.max" :key="'rating-'+i" class="empty half full" aria-hidden="true">
            <span class="icon" :class="getStarClass(i)" aria-hidden="true" />
        </li>
        <li class="review-count">({{ props.count }} {{ reviewMultiplicityName }})</li>
    </ul>
</template>
